import { z } from 'zod';
/**
 * lib.asset-downloaded v1 — 회원이 자료 다운로드를 확정(기록 커밋)한 사실.
 *
 * 발행 시점은 asset_downloads insert 와 같은 트랜잭션의 outbox 기록이다 —
 * presign URL 발급 전에 커밋되므로, 이 이벤트는 "다운로드 의사가 기록됐다"를
 * 뜻하며 실제 파일 수신 완료를 보장하지 않는다 (아키텍처 §3.4 순서).
 */
export const ASSET_DOWNLOADED_EVENT = 'lib.asset-downloaded';
export const assetDownloadedPayloadSchema = z.object({
    assetId: z.uuid(),
    memberId: z.uuid(),
    /** 다운로드 시점 제목 스냅샷 — 자료가 퍼지돼도 소비자는 제목을 안다 */
    assetTitle: z.string().min(1).max(200),
    videoId: z.uuid(),
    downloadedAt: z.iso.datetime(),
});
